import React from 'react';
import { APP_VERSION, BUILD_DATE } from '../version';

/**
 * Dashboard Header Component
 * Displays the main header with title, provider info, time, and version
 */
const DashboardHeader = ({ tradingStatus, currentTime, version, buildDate }) => {
  // Allow per-use override but default to the central version.js
  const v = version || APP_VERSION;
  const b = buildDate || BUILD_DATE;
  return (
    <div className="bg-gray-800 p-4 md:p-6 border-b border-gray-700">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
          <div className="w-full sm:w-auto">
            <h1 className="text-2xl md:text-3xl font-bold mb-2">Grid Trading Bot</h1>
            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-6 space-y-2 sm:space-y-0">
              <div className="flex items-center space-x-2">
                <span className="text-blue-400 text-sm md:text-base">Provider:</span>
                <span className="font-semibold text-blue-300 text-sm md:text-base">Hyperliquid</span>
              </div>
              {currentTime && (
                <div className="flex items-center space-x-2" data-testid="header-time-display">
                  <span className="text-gray-400 text-sm">|</span>
                  <span className="font-mono text-sm text-gray-300">
                    {currentTime.toLocaleString('en-US', {
                      hour: '2-digit', minute: '2-digit', second: '2-digit',
                      hour12: true, timeZoneName: 'short'
                    })}
                  </span>
                </div>
              )}
            </div>
          </div>
          {/* Version Number */}
          <div className="text-left sm:text-right mt-4 sm:mt-0 w-full sm:w-auto" data-testid="app-version-block">
            <div className="px-2 md:px-3 py-1 rounded text-xs md:text-sm font-mono">
              <span className="text-yellow-400 font-bold" data-testid="app-version">v{v}</span>
            </div>
            <div className="text-xs text-gray-500 mt-1" data-testid="app-build-info">
              Build: {b} • Backend {tradingStatus?.version || `v${v}`}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
